import React, { useEffect, useState } from 'react'
import { Row } from 'reactstrap';

//Components
import TextField from '../../../components/TextField/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Contratos from '../../../views/Cadastros/Geradores/components/Contratos';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';
import { transformValueFloattoFormated } from '../../../helpers/formats';


export default function ContratosPGRS({ pgrs, setPgrs, contratosGerador, gerador, setGerador }) {
  const { setupVariavel } = useAuth();

  //Estado de controle do formulario de contratos do passo de contratos
  const [openContratos, setOpenContratos] = useState(false);

  const handleChangeContrato = (contrato) => {
    const _pgrs = { ...pgrs };
    const existeContrato = _pgrs.contratosPendentes.findIndex(x => x.id == contrato.id);

    if (existeContrato === -1) {
      _pgrs.contratosPendentes = [..._pgrs.contratosPendentes, { ...contrato, checked: true, contratoPendentePGRS: true, situacaoContrato: "Pendente" }];
    } else {
      const contratoAtual = _pgrs.contratosPendentes[existeContrato];

      if (contratoAtual.checked) {
        _pgrs.contratosPendentes = _pgrs.contratosPendentes.filter(x => x.id != contrato.id);
      }
    }
    setPgrs(_pgrs);
  };


  //Cabeçalhos da tabela de contratos
  const headers = [
    {
      value: "Marcar", objectValue: "tbGeradoresContratos_Id", options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const contrato = contratosGerador[dataIndex];
          const isChecked = pgrs.contratosPendentes.some(c => c.id === contrato.id && c.checked);

          return (
            <TextField
              type={"checkbox"}
              value={isChecked}
              onChange={() => handleChangeContrato(contrato)}
            />
          );
        }
      }
    },
    { value: "Transportador", objectValue: "transportador", align: "left" },
    { value: "Endereço", objectValue: "endereco", align: "left" },
    { value: "Tipo de Coleta", objectValue: "tipoColeta", align: "left" },
    { value: "Frequência", objectValue: "frequencia", align: "left" },
    { value: "Volumetria", objectValue: "volumetria", align: "left" },
    {
      value: "Quantidade Contratada", objectValue: "quantidadeContratada", align: "left", options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <> {contratosGerador[dataIndex].quantidadeContratada ? mascaras.floatMask(contratosGerador[dataIndex].quantidadeContratada) : "0,00"}</>
        }
      }
    }
  ];

  useEffect(() => {
    if (gerador && (setupVariavel?.quemCadastraContrato === "Gerador" || setupVariavel?.quemCadastraContrato === "Transportador/Gerador")) {
      const _pgrs = { ...pgrs };
      let _localidades = gerador?.localidades.map(item => ({
        ...item,
        contratos: item?.contratos?.filter(x => x.situacaoContrato === "Pendente")
      }));

      let _contratosPendentes = [];

      _localidades.forEach(item => {
        let _endereco = `${item?.bairro ?? ""}, ${item?.numero ?? ""} - ${item?.logradouro ?? ""}, ${item?.cidade ?? ""} - ${item?.uf ?? ""}, ${item?.cep ?? ""}`;

        const contratosComEndereco = item.contratos.map(contrato => ({
          ...contrato,
          endereco: _endereco
        }));

        _contratosPendentes.push(...contratosComEndereco);
      });

      // Atualizar ou adicionar contratos pendentes
      const contratosPendentesAtualizados = _pgrs.contratosPendentes.map(item => {
        const contratoAtualizado = _contratosPendentes.find(x => x.tbTipoColeta_Id == item.tbTipoColeta_Id && x.tbGeradorLocalidade_id == item.tbGeradorLocalidade_id);

        if (contratoAtualizado)
          return { ...item, ...contratoAtualizado };

        // Retornar contrato original se não for encontrado para atualização
        return item;
      });

      // Adicionar contratos novos que não estão na lista
      const contratosPendentesAdicionados = _contratosPendentes.filter(contrato =>
        !_pgrs.contratosPendentes.some(existingContrato =>
          existingContrato.tbTipoColeta_Id == contrato.tbTipoColeta_Id && existingContrato.tbGeradorLocalidade_id == contrato.tbGeradorLocalidade_id
        )
      );

      _pgrs.contratosPendentes = [...contratosPendentesAtualizados, ...contratosPendentesAdicionados];

      if (_pgrs?.contratosPendentes?.length > 0) {
        _pgrs.contratosPendentes = _pgrs.contratosPendentes.map(value => {
          if (!!value.quantidadeContratada && value.quantidadeContratada.toString().includes(".")) {
            value.quantidadeContratada = transformValueFloattoFormated(value.quantidadeContratada)
          }
          return value
        })
      }

      setPgrs(_pgrs);
    }
  }, [gerador]);

  return (
    <div className='p-2 m-2'>
      {
        (setupVariavel?.quemCadastraContrato !== "Gerador" && setupVariavel?.quemCadastraContrato !== "Transportador/Gerador")
          ? <TabelaListagem
            headers={headers}
            items={contratosGerador}
            options={{ print: false, search: true, pagination: true }}
            title="Lista de contratos do gerador"
          />
          :
          <Row>
            {gerador && <Contratos
              gerador={gerador}
              setGerador={setGerador}
              openForm={openContratos}
              pgrs={true}
              setOpenForm={setOpenContratos}
              integracaoCadastros={setupVariavel?.integracaoCadastros}
            />}
          </Row>
      }
    </div>
  )
}
